import { render, staticRenderFns } from "./SalePageBasic.vue?vue&type=template&id=714ca4ae&scoped=true&"
import script from "./SalePageBasic.vue?vue&type=script&lang=js&"
export * from "./SalePageBasic.vue?vue&type=script&lang=js&"
import style0 from "./SalePageBasic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714ca4ae",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VImg,VProgressCircular,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('714ca4ae')) {
      api.createRecord('714ca4ae', component.options)
    } else {
      api.reload('714ca4ae', component.options)
    }
    module.hot.accept("./SalePageBasic.vue?vue&type=template&id=714ca4ae&scoped=true&", function () {
      api.rerender('714ca4ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SalePage/components/SalePageBasic.vue"
export default component.exports